import axios from 'axios';
import useUtils from '../../components/hooks/useUtils';
const { formatAmount, doCopy } = useUtils();

const defaultRequest = { credit_amount: "40000", credit_duration: "60", incl_insurance: 1 };
// const defaultRequest = { credit_amount: "40000", credit_duration: "60", incl_insurance: 1, id: 1, user_id: 24 };
const defaultAddIncomes = [{amount: "", type: ""}];
const defaultOpenLoans = [{bank: "", month_rate: "", open_balance: ""}];
const defaultOpenBalances = [{issuer: "", month_rate: "", open_balance: ""}];

const state = {
	request: doCopy(defaultRequest),
	request_base_confirmed: false,
	cur_address: {},
	old_address: {},
	employer_address: {},
	user: {},
	add_incomes: doCopy(defaultAddIncomes),
	children: [],
	open_loans: doCopy(defaultOpenLoans),
	open_balances: doCopy(defaultOpenBalances),
	dashboard: {},
	dashboard_filter: 1,
	final_conditions: {},
	task: {},
	taskHistory: [],
	allowance: {},
	success: false,
	loading: false,
	message: "",
	send_email_message: "",
	todo: {},
	offer_step: 0
}

const mutations = {
	UPDATE_SAVE_CUSTOMER(state, payload) {
		if (payload.success) {
			state.request = payload.data.request;
			state.user = payload.data.user;
			setSuccessState(state, payload.message);
		} else {
			setErrorState(state, payload.message);
		}
	},
	UPDATE_SAVE_USER(state, payload) {
		if (payload.success) {
			state.user = payload.data;
			setSuccessState(state, payload.message);
		} else {
			setErrorState(state, payload.message);
		}
	},
	UPDATE_SAVE_CUSTOMER_WHOLE_DATA(state, payload) {
		if (payload.success) {
			state.request = payload.data.request ? payload.data.request : {};
			state.request_base_confirmed = payload.data.request ? true : false
			state.user = payload.data.user ? payload.data.user : {};
			state.cur_address = payload.data.cur_address ? payload.data.cur_address : {};
			state.old_address = payload.data.old_address ? payload.data.old_address : {};
			state.employer_address = payload.data.employer_address ? payload.data.employer_address : {};
			state.add_incomes = payload.data.add_incomes;
			state.children = payload.data.children;
			state.open_loans = payload.data.open_loans;
			state.open_balances = payload.data.open_balances;
			state.allowance = payload.data.allowance;
			state.todo = payload.data.todo;
			setSuccessState(state, payload.message);
		}
		else {
			setErrorState(state, payload.message);
		}
	},
	UPDATE_SAVE_REQUEST(state, payload) {
		if (payload.success) {
			state.request = payload.data.request;
			setSuccessState(state, payload.message);
		}
		else {
			setErrorState(state, payload.message);
		}
	},
	UPDATE_SAVE_REASONS_REQUEST(state, payload) {
		if (payload.success) {
			state.request = payload.data;
			setSuccessState(state, payload.message);
		}
		else {
			setErrorState(state, payload.message);
		}
	},
	UPDATE_SAVE_BASECOND(state, payload) {
		if (payload.success) {
			state.request = payload.data.request
			state.cur_address = payload.data.cur_address
			state.old_address = payload.data.old_address
			// state.employer_address = payload.data.employer_address;
			setSuccessState(state, payload.message)
		} else {
			setErrorState(state, payload.message)
		}
	},
	UPDATE_SAVE_INCOME(state, payload) {
		if (payload.success) {
			state.request = payload.data.request
			state.employer_address = payload.data.employer_address;
			state.add_incomes = payload.data.add_incomes;
			setSuccessState(state, payload.message)
		} else {
			setErrorState(state, payload.message)
		}
	},
	UPDATE_SAVE_EXPENSES(state, payload) {
		if (payload.success) {
			state.request = payload.data.request;
			state.open_loans = payload.data.open_loans;
			state.open_balances = payload.data.open_balances;
			state.allowance = payload.data.allowance;
			state.children = payload.data.children;
			setSuccessState(state, payload.message);
		}
		else {
			setErrorState(state, payload.message);
		}
	},
	UPDATE_SAVE_PRIVACY_CONSENT(state, payload) {
		if (payload.success) {
			setSuccessState(state, payload.message);
		}
		else {
			setErrorState(state, payload.message);
		}
	},
	UPDATE_SAVE_DASHBORD_CUSTOMER(state, payload) {
		state.request = payload.data.request;
		state.user = payload.data.user;
		state.cur_address = payload.data.cur_address;
		state.old_address = payload.data.old_address;
		state.allowance = payload.data.allowance;
		if (payload.success) {
			setSuccessState(state, payload.message);
		}
		else {
			setErrorState(state, payload.message);
		}
	},
	UPDATE_SAVE_DASHBORD_EARNINGS(state, payload) {
		state.request = payload.data.request;
		state.employer_address = payload.data.employer_address;
		state.add_incomes = payload.data.add_incomes;
		state.allowance = payload.data.allowance;
		if (payload.success) {
			setSuccessState(state, payload.message);
		}
		else {
			setErrorState(state, payload.message);
		}
	},
	UPDATE_SAVE_DASHBORD_EXPENSES(state, payload) {
		state.request = payload.data.request;
		state.open_loans = payload.data.open_loans;
		state.open_balances = payload.data.open_balances;
		state.children = payload.data.children;
		state.allowance = payload.data.allowance;
		if (payload.success) {
			setSuccessState(state, payload.message);
		}
		else {
			setErrorState(state, payload.message);
		}
	},
	UPDATE_SAVE_FINAL_CONDITIONS(state, payload) {
		if (payload.success) {
			state.final_conditions = (payload.data ? payload.data : {});
			setSuccessState(state, payload.message);
		}
		else {
			setErrorState(state, payload.message);
		}
	},
	UPDATE_SAVE_TASK(state, payload) {
		if (payload.success) {
			state.task = (payload.data ? payload.data : {});
			setSuccessState(state, payload.message);
		}
		else {
			setErrorState(state, payload.message);
		}
	},
	RESET_STATE(state) {
		state.request = doCopy(defaultRequest);
		state.cur_address = {};
		state.old_address = {};
		state.employer_address = {};
		state.user = {};
		state.add_incomes = doCopy(defaultAddIncomes);
		state.children = [];
		state.open_loans = doCopy(defaultOpenLoans);
		state.open_balances = doCopy(defaultOpenBalances);
		state.final_conditions = {};
		state.allowance = {amount: ''};
		state.task = {};
	},
	UPDATE_AMOUNT(state, payload) {
		state.request.credit_amount = payload;
	},
	UPDATE_DURATION(state, payload) {
		state.request.credit_duration = payload;
	},
	UPDATE_INCL_INSURANCE(state, payload) {
		state.request.incl_insurance = payload;
	},
	UPDATE_USER(state, payload) {
		state.user = payload;
	},
	UPDATE_DASHBOARD_FILTER(state, payload) {
		state.dashboard_filter = payload;
	},
	UPDATE_LOADING(state) {
		setLoadingState(state);
	},
	UPDATE_DASHBOARD(state, payload) {
		if (payload.success) {
			state.dashboard = payload.data;
			setSuccessState(state, payload.message);
		} else {
			setErrorState(state, payload.message);
		}
	},
	UPDATE_USER_FIRM(state, payload) {
		state.user.firm_id = payload;
	},
	UPDATE_USER_ID(state, payload) {
		state.user.id = payload;
	},
	UPDATE_SEND_EMAIL(state, payload) {
		if (payload.success) {
			setSuccessState(state, payload.message);
		} else {
			setErrorState(state);
		}
	},
	UPDATE_SEND_EMAIL_MESSAGE(state, payload) {
		state.send_email_message=payload.message;
	},
	RESET_SEND_EMAIL_MESSAGE(state) {
		state.send_email_message="";
	},
	UPDATE_ERROR(state, payload) {
		setErrorState(state, payload);
	},
	UPDATE_TASK_HISTORY(state, payload) {
		if (payload.success) {
			state.taskHistory = doCopy(payload.data);
			setSuccessState(state, payload.message);
		} else {
			setErrorState(state, payload.message);
		}
	},
	UPDATE_SAVE_TODO(state, payload) {
		if (payload.success) {
			state.todo = doCopy(payload.data);
			setSuccessState(state, payload.message);
		} else {
			setErrorState(state, payload.message);
		}
	},
	UPDATE_OFFERSTEP(state, payload) {
		state.offer_step = payload;
	}
}

const actions = {
	/** save new customer */
	store({ commit }, customerData) {
		commit('UPDATE_LOADING');
		return new Promise((resolve, reject) => {
			axios
			.post('/customer/store', customerData)
			.then((response) => {
				commit('UPDATE_SAVE_CUSTOMER', response.data);
				resolve();
			})
			.catch(function(error) {
				commit('UPDATE_ERROR', error);
				reject();
			});
		});
	},
	/** save base condition */
	store_basecond({ commit }, basecondData) {
		commit('UPDATE_LOADING');
		axios
		.post('/customer/update_basecond', basecondData)
		.then((response) => {
			commit('UPDATE_SAVE_BASECOND', response.data);
		})
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
	/** save income data */
	store_income({ commit }, incomeData) {
		commit('UPDATE_LOADING');
		axios
		.post('/customer/update_income', incomeData)
		.then((response) => {
			commit('UPDATE_SAVE_INCOME', response.data);
		})
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
	/** save partner income data */
	store_partner_income({ commit }, partnerData) {
		commit('UPDATE_LOADING');
		axios
		.post('/customer/update_partner_income', partnerData)
		.then((response) => {
			commit('UPDATE_SAVE_REQUEST', response.data);
		})
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
	/** save expenses data */
	store_expenses({ commit }, expensesData) {
		commit('UPDATE_LOADING');
		return new Promise((resolve, reject) => {
			axios
			.post('/customer/update_expenses', expensesData)
			.then((response) => {
				commit('UPDATE_SAVE_EXPENSES', response.data);
				resolve();
			})
			.catch(function (error) {
				commit('UPDATE_ERROR', error);
				reject();
			});
		})
	},
	/** save privacy consent data */
	store_privacy_consent({ commit }, privacyConsentData) {
		commit('UPDATE_LOADING');
		return new Promise((resolve, reject) => {
			axios
			.post('/customer/update_privacy_consent', privacyConsentData)
			.then((response) => {
				commit('UPDATE_SAVE_PRIVACY_CONSENT', response.data);
				resolve();
			})
			.catch(function(error) {
				commit('UPDATE_ERROR', error);
				reject();
			});
		});
	},
	/** update recommendation data */
	update_recommendation({ commit }, recommendationData) {
		commit('UPDATE_LOADING');
		return new Promise((resolve, reject) => {
			axios
			.post('/customer/update_recommendation', recommendationData)
			.then((response) => {
				commit('UPDATE_SAVE_REQUEST', response.data);
				resolve();
			})
			.catch(function(error) {
				commit('UPDATE_ERROR', error);
				reject();
			});
		});
	},
	/** update incl insurance data */
	update_incl_insurance({ commit }, inclInsuranceData) {
		commit('UPDATE_LOADING');
		return new Promise((resolve, reject) => {
			axios
			.post('/customer/update_incl_insurance', inclInsuranceData)
			.then((response) => {
				commit('UPDATE_SAVE_REQUEST', response.data);
				resolve();
			})
			.catch(function(error) {
				setErrorState(state, error);
				reject();
			});
		});
	},
	/** update recommendation data */
	store_interest({ commit }, interestData) {
		commit('UPDATE_LOADING');
		axios
		.post('/customer/update_interest', interestData)
		.then((response) => {
			commit('UPDATE_SAVE_REQUEST', response.data);
		})
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
	/** save privacy consent data */
	store_status({ commit }, data) {
		commit('UPDATE_LOADING');
		const request = {'id': state.request.id, 'status': parseInt(data.status), 'reason': data.reason};
		axios
			.post('/customer/update_status', { request: request })
			.then((response) => {
				commit('UPDATE_SAVE_REQUEST', response.data);
			})
			.catch(function(error) {
				commit('UPDATE_ERROR', error);
			});
	},
	/** save privacy consent data */
	store_request_base_confirmed({ commit }, request_base_confirmed) {
		state.request_base_confirmed = request_base_confirmed
	},
	/** reset added customer */
	reset({ commit }) {
		commit('RESET_STATE');
	},
	/** send offer to customer
	 * @ params - object {userId, showPopup}
	*/

	sendOffer({ commit }, params) {
		const {userId = null, showPopup = false} = (typeof params === 'object') ? params : {};//define default param values
		if (userId || state.user.hasOwnProperty('id')) {
			commit('UPDATE_LOADING');
			axios
			.get("/customer/sendOffer?userId=" + (userId ? userId : state.user.id)).then((response) => {
				commit('UPDATE_SEND_EMAIL', response.data);
				if (showPopup) {
					commit('UPDATE_SEND_EMAIL_MESSAGE', response.data);
				}
			})
			.catch(function(error) {
				commit('UPDATE_SEND_EMAIL', {success: false, loading: false, message: error});
				if (showPopup) {
					commit('UPDATE_SEND_EMAIL_MESSAGE', {message: error});
				}
			});
		}
	},
	/**
	 * load customer
	 * @param customerId
	 */
	load({ commit }, customerId) {
		commit('UPDATE_LOADING');
		axios
		.get("/customer/load/" + customerId).then((response) => {
			commit('UPDATE_SAVE_CUSTOMER', response.data);
		})
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
	/**
	 * load customer whole data
	 * @param customerId
	 */
	loadWholeData({ commit }, userId) {
		commit('UPDATE_LOADING');
		return new Promise((resolve, reject) => {
			axios
			.get("/customer/load_whole_data/" + userId).then((response) => {
				commit('UPDATE_SAVE_CUSTOMER_WHOLE_DATA', response.data);
				resolve();
			})
			.catch(function(error) {
				commit('UPDATE_ERROR', error);
				reject();
			});
		});
	},
	loadDashboard({ commit }, filter) {
		commit('UPDATE_LOADING');
		axios
		.get("/customer/loadDashboard/" + filter).then((response) => {
			commit('UPDATE_DASHBOARD', response.data);
		})
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
	/**
	 * load customer final conditions
	 * @param userId
	 */
	 loadFinalConditions({ commit }, userId) {
		commit('UPDATE_LOADING');
		axios
		.get("/customer/finalConditions" + (userId ? "/"+userId : "")).then((response) => {
			commit('UPDATE_SAVE_FINAL_CONDITIONS', response.data);
		})
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
	saveFinalConditions({ commit }, finalConditions) {
		commit('UPDATE_LOADING');
		axios
		.post("/customer/finalConditions", finalConditions).then((response) => {
			commit('UPDATE_SAVE_FINAL_CONDITIONS', response.data);
		})
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
	saveCancellationsReasons({ commit }, finalConditions) {
		commit('UPDATE_LOADING');
		return new Promise((resolve, reject) => {
			axios
			.post("/customer/update_cancellation_reasons", finalConditions)
			.then((response) => {
				commit('UPDATE_SAVE_REASONS_REQUEST', response.data);
				resolve();
			})
			.catch(function(error) {
				commit('UPDATE_ERROR', error);
				reject();
			});
		});
	},
	saveHasEnyCreditCard({ commit }, user) {
		commit('UPDATE_LOADING');
		axios
			.post("/customer/updateHasEnyCreditCard", user).then((response) => {
				commit('UPDATE_SAVE_USER', response.data);
			})
			.catch(function(error) {
				commit('UPDATE_ERROR', error);
			});
	},
	/**
	 * load customer task
	 * @param userId
	 */
	 loadTask({ commit }, userId) {
		commit('UPDATE_LOADING');
		axios
		.get("/customer/task/" + userId).then((response) => {
			commit('UPDATE_SAVE_TASK', response.data);
			commit('UPDATE_USER_ID', userId);
		})
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
	saveTask({ commit }, task) {
		commit('UPDATE_LOADING');
		axios
		.post("/customer/task", task).then((response) => {
			commit('UPDATE_SAVE_TASK', response.data);
		})
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
	loadTaskHistory({ commit }, userId) {
		commit('UPDATE_LOADING');
		axios
		.get("/customer/task/history/" + userId).then((response) => {
			commit('UPDATE_TASK_HISTORY', response.data);
		})
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
	saveTodo({ commit }, todo) {
		commit('UPDATE_LOADING');
		axios
		.post("/customer/todo", todo).then((response) => {
			commit('UPDATE_SAVE_TODO', response.data);
		})
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
	/** save dashboard customer data */
	store_dashboard_customer_data({ commit }, dashboardCustomerData) {
		commit('UPDATE_LOADING');
		axios
		.post('/customer/update_dashbord_customer_data', dashboardCustomerData)
		.then((response) => {
			commit('UPDATE_SAVE_DASHBORD_CUSTOMER', response.data);
		})
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
	/** save dashboard customer data */
	store_dashboard_earnings_data({ commit }, dashboardEarningsData) {
		commit('UPDATE_LOADING');
		axios
		.post('/customer/update_dashbord_earnings_data', dashboardEarningsData)
		.then((response) => {
			commit('UPDATE_SAVE_DASHBORD_EARNINGS', response.data);
		})
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
	/** save dashboard customer data */
	store_dashboard_expenses_data({ commit }, dashboardExpensesData) {
		commit('UPDATE_LOADING');
		axios
		.post('/customer/update_dashboard_expenses_data', dashboardExpensesData)
		.then((response) => {
			commit('UPDATE_SAVE_DASHBORD_EXPENSES', response.data);
		})
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
	update_offer_step({ commit }, offerStep) {
		commit('UPDATE_OFFERSTEP', offerStep);
	},
}

const getters = {
	request: state => state.request,
	request_base_confirmed: state => state.request_base_confirmed,
	employer_address: state => state.employer_address,
	cur_address: state => state.cur_address,
	old_address: state => state.old_address,
	user: state => state.user,
	dashboard: state => state.dashboard,
	dashboard_filter: state => state.dashboard_filter,
	add_incomes: state => state.add_incomes,
	children: state => state.children,
	open_loans: state => state.open_loans,
	open_balances: state => state.open_balances,
	amount_view: state => formatAmount(state.request.credit_amount, 0),
	final_conditions: state => state.final_conditions,
	allowance: state => state.allowance,
	task: state => state.task,
	taskHistory: state => state.taskHistory,
	success: state => state.success,
	loading: state => state.loading,
	message: state => state.message,
	send_email_message: state => state.send_email_message,
	todo: state => state.todo,
	offer_step: state => state.offer_step,
}

function setLoadingState(state) {
	state.success = false;
	state.loading = true;
	state.message = "";
}

function setSuccessState(state, message = "") {
	state.success = true;
	state.loading = false;
	state.message = message;
}

function setErrorState(state, message = "") {
	state.success = false;
	state.loading = false;
	state.message = message;
}

const customerModule = {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}

export default customerModule;
